module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-translate-mode-column"
  }, [_c('div', {
    staticClass: "plekan-row-list",
    class: {
      empty: !_vm.rows.length, translate: _vm.isTranslate
    },
    attrs: {
      "id": "plekan-sortable-list"
    }
  }, _vm._l((_vm.rows), function(r, key) {
    return _c('div', {
      key: r.index,
      staticClass: "plekan-row-item animated fadeIn transition-component"
    }, [_c('div', {
      staticClass: "plekan-tools"
    }, [(!_vm.isTranslate) ? _c('span', {
      staticClass: "plekan-move-row"
    }, [_c('i', {
      staticClass: "fa fa-hand-grab-o"
    })]) : _vm._e(), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.editAsHTMLRow(r, key, _vm.language)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-html5"
    })]), _vm._v(" "), (!_vm.isTranslate) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.deleteRow(r, key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e(), _vm._v(" "), (!_vm.isTranslate) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.dublicateRow(r, key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-copy"
    })]) : _vm._e()]), _vm._v(" "), _c(r.name, {
      tag: "component",
      attrs: {
        "index": key,
        "store": _vm.store,
        "displayLanguage": _vm.language
      }
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8b9001e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/arenaColumn.vue
// module id = 118
// module chunks = 0